import styled from "styled-components";

export const ActionButton = styled.button`
    border: 1px solid #2CAAE5;
    background-color: #1d2643;
    color: white;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 11px;
    text-transform: lowercase;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    
    &:hover {
        background-color: #2a3654;
        border-color: #3CBAF5;
        transform: translateY(-1px);
    }
    
    &:active {
        transform: translateY(0);
    }
    
    span {
        font-size: 14px;
    }
`